import { apiResponseCode } from "../constant/network"
import stdbApi from "../api/stdb"

export default {
    async loginStdb(accountId, password) {
        const params = {
            userId: accountId,
            password: password,
            autoLogin: false,
            forceLogin: true,            
        }
        const response = await stdbApi.login(params)
        console.log(response)
        if (response.status != apiResponseCode.ok) {
            return undefined
        }
        if (!response.data || response.data.resultCode != "00000") {
            return undefined
        }
        return response.data.apiToken
    },
    async loginStdbSocial(accountId, token) {
        const params = {
            userId: accountId,
            status: 200,
            token: token,
            autoLogin: false,
            forceLogin: true,            
        }
        const response = await stdbApi.login(params)
        console.log(response)
        if (response.status != apiResponseCode.ok) {
            return undefined
        }
        if (!response.data || response.data.resultCode != "00000") {
            return undefined
        }
        return response.data.apiToken
    },

    async downloadProblem(params) {
        try {
            const response = await stdbApi.downloadProblem(params)
            if (response.status != apiResponseCode.ok) {
                return undefined
            }
            if (!response.data || response.data.result_code != "00000") {
                return undefined
            }
            return response.data
        } catch (e) {
            console.error(e)
            return undefined
        }
    },

    async downloadProblemZip(downloadUrl) {
        try {
            return await stdbApi.downloadProblemZip(downloadUrl)
        } catch (e) {
            console.error(e)
            return undefined
        }
    },
}